/**
 * ExcludeEmptyState — what the tab says when there are no rules yet.
 * For Media Devoted | Created By Ciro Autiero
 *
 * The old copy described the engine ("a rule's action (today: exclude) applies
 * to matching items…") and was also out of date. Say what a rule is FOR, in the
 * order someone would ask it — and only what this tracker runs: without a
 * queue (Tres Commas) a rule can only freeze or pin the weighting.
 */

import { FC } from 'react';
import { Plus } from 'lucide-react';

import { Button } from '@/components/ui/layout/Button';
import { useDrawerProfile } from '@/features/flow-optimizer/tracker';

export interface ExcludeEmptyStateProps {
  onAdd: () => void;
}

const LEAD =
  'No rules yet. A rule watches your live elements and, when its conditions match, does what you tell it —';
/** Voluum / Binom (and outside a drawer): the copy as it always read. */
const WITH_QUEUE = `${LEAD} freeze the weighting, send one back to the queue, or swap it for the next in line.`;
const WITHOUT_QUEUE = `${LEAD} freeze the weighting or pin its share.`;

export const ExcludeEmptyState: FC<ExcludeEmptyStateProps> = ({ onAdd }) => {
  const { queue } = useDrawerProfile();
  return (
    <div className="flex flex-col items-center justify-center gap-2 rounded-lg border border-dashed border-border bg-muted/20 px-4 py-8 text-center">
      <p className="max-w-md text-[12px] leading-relaxed text-muted-foreground">
        {queue ? WITH_QUEUE : WITHOUT_QUEUE}
      </p>
      <Button
        type="button"
        variant="outline"
        size="sm"
        onClick={onAdd}
        className="h-8 px-3 text-xs"
      >
        <Plus className="mr-1 h-3.5 w-3.5" aria-hidden />
        Add your first rule
      </Button>
    </div>
  );
};

export default ExcludeEmptyState;
